import React from 'react';
import { Link } from 'react-router-dom';
import { useOrgStore } from '../store/org';
import { moduleRouteDenied } from '../auth/capabilities';
import { DemoBanner, VpState } from './VelopulseShell';

/**
 * 前端模組路由閘道：未開通時顯示友善說明，不靜默空白。
 * module：單一模組；anyOf：任一即可（例如商機）。
 */
export default function RequireModule({ module, anyOf, children, title = '無法使用此功能' }) {
  const currentOrg = useOrgStore((s) => s.currentOrg);
  const orgs = useOrgStore((s) => s.orgs);
  const denied = moduleRouteDenied(currentOrg, { module, anyOf });

  if (!currentOrg && orgs === null) {
    return <div className="vp-content"><VpState loading /></div>;
  }

  if (denied) {
    return (
      <div className="vp-content" style={{ maxWidth: 560 }}>
        <DemoBanner />
        <div className="vp-card">
          <h1 style={{ fontSize: 20, marginBottom: 8 }}>{title}</h1>
          <p className="vp-muted" style={{ marginBottom: 16 }}>{denied}</p>
          <div className="vp-actions" style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link className="vp-btn" to="/">回工作台</Link>
            <Link className="vp-btn" to="/orgs">切換公司</Link>
          </div>
        </div>
      </div>
    );
  }

  return children;
}
